// extracted by mini-css-extract-plugin
export default {"gainAccessWrapper":"styles_gainAccessWrapper__upSHL","titleContainer":"styles_titleContainer__UzBnS","formWrapper":"styles_formWrapper__mJX7q"};